<template>
    <div class="category-nav" :class="{ small: isSmallView }">
        <div
            v-if="isSmallView"
            class="scroll-arrow-holder"
            :class="{ disabled: Number.isNaN(scrolledDistance) || scrolledDistance <= 0 }"
            @click="scroll(true)"
        >
            <svg-icon icon-holder-class="scroll-arrow" icon-id="icon-page-left" />
        </div>
        <div ref="categories" class="categories">
            <div
                v-for="cat in categories"
                :key="cat.no"
                :data-ga="`Store Nav|${cat.no}`"
                class="category"
                :class="{ selected: cat.no === category.no }"
                data-cy="category"
                @click="changeCategory(cat)"
            >
                {{ cat.no === 0 ? $t(`shop.${cat.name}`) : cat.name }}
            </div>
        </div>
        <div
            v-if="isSmallView"
            class="scroll-arrow-holder"
            :class="{ disabled: Number.isNaN(scrolledDistance) || scrolledDistance >= 1 }"
            @click="scroll"
        >
            <svg-icon icon-holder-class="scroll-arrow" icon-id="icon-page-right" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

const SMALL_VIEW_BREAKPOINT = 768;
const SCROLL_DISTANCE = 150;
const SCROLL_INTERVAL_DISTANCE = 10;

export default {
    name: 'CategoryNav',
    components: {
        svgIcon,
    },
    props: {},
    data() {
        return {
            windowWidth: 0,
            scrolledDistance: 0,
        };
    },
    computed: {
        ...mapState(['categories', 'category']),
        isSmallView() {
            return this.windowWidth <= SMALL_VIEW_BREAKPOINT;
        },
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.setWindowWidth);

            this.setWindowWidth();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setWindowWidth);
    },
    methods: {
        setWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
            this.setScrollDistance();
        },
        changeCategory(category) {
            if (this.category.no === category.no) return;
            this.$router.push({ name: 'product-list', params: { category: category.no } });
        },
        scroll(scrollLeft) {
            const categories = this.$refs.categories;
            let scrollDistance = 0;
            let intervalDistance = SCROLL_INTERVAL_DISTANCE;
            if (scrollLeft === true) intervalDistance *= -1;
            let scrollTimer = setInterval(() => {
                categories.scrollLeft += intervalDistance;
                scrollDistance += SCROLL_INTERVAL_DISTANCE;
                if (scrollDistance >= SCROLL_DISTANCE) {
                    window.clearInterval(scrollTimer);
                    this.setScrollDistance();
                }
            }, 25);
        },
        setScrollDistance() {
            const categories = this.$refs.categories;
            this.scrolledDistance = categories.scrollLeft / (categories.scrollWidth - categories.clientWidth);
        },
    },
};
</script>

<style lang="less" scoped>
@category-bg-color: #31333d;

.category-nav {
    &.small {
        .categories .category {
            margin-right: 0;
            &:hover {
                background-color: @category-bg-color;
                color: #fffefe;
            }
            &:active {
                background-color: @category-bg-color;
                color: #666;
            }
            &.selected {
                background-color: @category-bg-color;
                color: #fff;
            }
        }
    }
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 40px;
    margin: 0 auto 40px;
    .categories {
        color: #999;
        display: flex;
        font-size: 13px;
        height: 100%;
        overflow: hidden;
        text-transform: uppercase;
        width: 100%;
        .category {
            align-items: center;
            background-color: @category-bg-color;
            display: flex;
            justify-content: center;
            margin-right: 1px;
            overflow: hidden;
            user-select: none;
            width: 100%;
            &:hover {
                background-color: #494c59;
            }
            &:active {
                background-color: #212329;
                color: #737373;
            }
            &.selected {
                background-color: #fff;
                color: #313131;
                font-weight: bold;
            }
        }
    }
    .scroll-arrow-holder {
        align-items: center;
        background-color: #393b47;
        display: flex;
        height: 100%;
        justify-content: center;
        width: 40px;
        &:hover {
            background-color: #474a59;
        }
        &:active {
            background-color: #2d2f38;
            .scroll-arrow {
                opacity: 0.5;
            }
        }
        &.disabled {
            cursor: default;
            background-color: #393b47;
            .scroll-arrow {
                opacity: 0.2;
            }
        }
        .scroll-arrow {
            height: 10px;
            width: 6px;
        }
    }
}
@media (max-width: 1024px) {
    .category-nav {
        margin-bottom: 30px;
    }
}
@media (max-width: 768px) {
    .category-nav {
        margin-bottom: 10px;
        .categories .category {
            min-width: 141px;
        }
    }
}
</style>
